export default __webpack_public_path__ + "static/media/ico-warning.807124f0.svg";